/* مُتأبّد — page atmosphere behind the content: المارد's blue smoke drifting through the page and warm lantern
   embers rising. One fragment shader at half resolution, ~30fps, paused when hidden; a single still frame for
   reduced motion. The smoke moves slower than the page on scroll (depth) and swirls gently around the pointer. */
(function(){
  var canvas = document.querySelector('.mh-atmos');
  if (!canvas) return;
  var gl = canvas.getContext('webgl', {alpha: true, antialias: false, depth: false, premultipliedAlpha: true, powerPreference: 'low-power'});
  if (!gl) { canvas.remove(); return; }
  var still = matchMedia('(prefers-reduced-motion: reduce)').matches;

  var vert = 'attribute vec2 p; void main(){ gl_Position = vec4(p, 0., 1.); }';
  var frag = [
    '#ifdef GL_FRAGMENT_PRECISION_HIGH\nprecision highp float;\n#else\nprecision mediump float;\n#endif',
    'uniform vec2 res; uniform float t, scroll; uniform vec3 mouse;',
    'float h(vec2 p){ p = fract(p * vec2(.1031, .1030)); p += dot(p, p.yx + 33.33); return fract((p.x + p.y) * p.x); }',
    'float n(vec2 p){ vec2 i = floor(p), f = fract(p); f = f * f * (3. - 2. * f);',
    '  return mix(mix(h(i), h(i + vec2(1, 0)), f.x), mix(h(i + vec2(0, 1)), h(i + vec2(1, 1)), f.x), f.y); }',
    'float fbm(vec2 p){ float v = 0., a = .5; for (int i = 0; i < 5; i++) { v += a * n(p); p = p * 2.02 + 3.1; a *= .5; } return v; }',
    'void main(){',
    '  vec2 uv = gl_FragCoord.xy / res.y;',
    '  float depth = scroll / res.y;',
    '  vec2 p = uv * 1.15 + vec2(0., depth * .3 - t * .007);',
    /* the smoke parts around the pointer */
    '  vec2 m = mouse.xy / res.y; vec2 dm = uv - m; float near = exp(-dot(dm, dm) * 22.) * mouse.z;',
    '  p += vec2(-dm.y, dm.x) * near * .15;',
    '  vec2 q = vec2(fbm(p + t * .009), fbm(p + vec2(5.2, 1.3) - t * .007));',
    '  float f = fbm(p + 1.5 * q + vec2(0., -t * .012));',
    '  float smoke = smoothstep(.45, .62, f);',
    '  float x = gl_FragCoord.x / res.x;',
    '  float side = .5 + .5 * (smoothstep(.38, 0., x) + smoothstep(.62, 1., x));',
    '  float a = smoke * .26 * side;',
    '  vec3 sc = mix(vec3(.28, .42, .9), vec3(.68, .8, 1.), smoke * smoke);',
    /* embers: one candidate per cell, few lit, rising and twinkling */
    '  float cell = 70.;',
    '  vec2 g = gl_FragCoord.xy / cell + vec2(0., -t * .07 + depth * res.y / cell * .22);',
    '  vec2 id = floor(g), fr = fract(g) - .5; float r = h(id);',
    '  vec2 off = vec2(h(id + 1.7) - .5, h(id + 3.1) - .5) * .6 + vec2(sin(t * .25 + r * 6.3) * .08, 0.);',
    '  float d = length(fr - off);',
    '  float tw = .6 + .4 * sin(t * .55 + r * 40.);',
    '  float e = step(.92, r) * (smoothstep(.06, 0., d) + smoothstep(.2, 0., d) * .3) * tw;',
    '  e *= .55 + .45 * side;',
    '  vec3 ec = vec3(1., .77, .45);',
    '  float al = clamp(a + e * .85, 0., 1.);',
    '  vec3 col = (sc * a + ec * e) / max(a + e, .0001);',
    '  gl_FragColor = vec4(col * al, al);',  /* premultiplied: Safari and Chrome composite it the same way */
    '}'
  ].join('\n');

  function sh(type, src){ var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null; }
  var vs = sh(gl.VERTEX_SHADER, vert), fs = sh(gl.FRAGMENT_SHADER, frag);
  if (!vs || !fs) { canvas.remove(); return; }
  var pr = gl.createProgram(); gl.attachShader(pr, vs); gl.attachShader(pr, fs); gl.linkProgram(pr);
  if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) { canvas.remove(); return; }
  gl.useProgram(pr);
  var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
  var loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
  var U = {res: gl.getUniformLocation(pr, 'res'), t: gl.getUniformLocation(pr, 't'), scroll: gl.getUniformLocation(pr, 'scroll'), mouse: gl.getUniformLocation(pr, 'mouse')};
  /* one full-screen pass straight into a cleared canvas: no blending (it would square the alpha) */

  /* The canvas is sized to the tallest the viewport gets (CSS 100lvh), so a phone's address bar showing or hiding
     near the end of a page doesn't rescale the smoke; only a real width change rebuilds it. */
  var scale = .5, W = 0, H = 0, lastW = 0;
  function size(){
    var w = innerWidth, h = Math.max(canvas.clientHeight, innerHeight);
    if (w === lastW && Math.round(h * scale) <= H) return;
    lastW = w;
    W = Math.max(1, Math.round(w * scale)); H = Math.max(1, Math.round(h * scale));
    canvas.width = W; canvas.height = H; gl.viewport(0, 0, W, H); gl.uniform2f(U.res, W, H);
    if (still) draw(40);
  }
  /* the page's real scroll range: the elastic bounce past either end would shake the smoke */
  function scrolled(){ return Math.min(Math.max(scrollY, 0), Math.max(0, document.documentElement.scrollHeight - innerHeight)); }
  var mx = -1e4, my = -1e4, mz = 0, mzT = 0, drawnScroll = 0;
  addEventListener('pointermove', function(e){ if (e.pointerType !== 'mouse') return; mx = e.clientX * scale; my = (innerHeight - e.clientY) * scale; mzT = 1; }, {passive: true});
  document.addEventListener('pointerleave', function(){ mzT = 0; });
  function draw(time){
    mz += (mzT - mz) * .05;
    gl.uniform1f(U.t, time); gl.uniform1f(U.scroll, drawnScroll * scale); gl.uniform3f(U.mouse, mx, my, mz);
    gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT); gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  }
  addEventListener('resize', size); drawnScroll = scrolled(); size();
  canvas.classList.add('on');
  if (still) return;
  /* The smoke's depth follows the scroll with an ease rather than exactly, so momentum, small trackpad jitters and
     the bounce at a page's end are absorbed instead of shaking it; frames are drawn while it glides, ~30fps at rest. */
  var t0 = performance.now(), last = 0, prev = t0;
  (function loop(now){
    requestAnimationFrame(loop);
    if (document.hidden) { prev = now; return; }
    var target = scrolled(), k = 1 - Math.pow(.88, Math.min(4, (now - prev) / 16.7)), moving = Math.abs(target - drawnScroll) > .5;
    prev = now;
    if (!moving && now - last < 33) return;
    drawnScroll = moving ? drawnScroll + (target - drawnScroll) * k : target;
    last = now; draw((now - t0) / 1000);
  })(t0);
})();
